function Comp1() {
    $(function () {
        const $menu = $(".comp-1-select");
        const $allTabs = $("section[data-tab]");
        const $page = $("html, body");
        const SCROLL_OFFSET = 0;

        $allTabs.hide().attr("aria-hidden", "true");

        const closeAll = () => {
            $menu.find("a").attr("aria-selected", "false");
            $allTabs.stop(true, true).hide().attr("aria-hidden", "true");
        };

        const openTab = (key, { push = true, scroll = true } = {}) => {
            if (!key) {
                closeAll();
                if (push)
                    history.pushState(
                        null,
                        "",
                        location.pathname + location.search
                    );
                window.dispatchEvent(
                    new CustomEvent("tabchange", { detail: { key: null } })
                );
                return;
            }

            const $link = $menu.find(`a[href="#${key}"]`).first();
            const $tab = $allTabs.filter(`[data-tab="${key}"]`);

            if (!$link.length || !$tab.length) return;

            closeAll();
            $link.attr("aria-selected", "true");

            $tab.stop(true, true).fadeIn(200, function () {
                $(this).attr("aria-hidden", "false");
                if (scroll) {
                    const top = Math.max(
                        0,
                        $(this).offset().top - SCROLL_OFFSET
                    );
                    $page.stop(true).animate({ scrollTop: top }, 600);
                }
            });

            if (push) history.pushState(null, "", `#${key}`);
            window.dispatchEvent(
                new CustomEvent("tabchange", { detail: { key } })
            );
        };

        // click
        $menu.on("click", 'a[href^="#"]', function (e) {
            if ($(e.target).closest(".comp-1-select-item-close").length) return;
            e.preventDefault();
            const key = (this.hash || "").slice(1).trim();
            if (key) openTab(key, { push: true });
        });

        // close
        $menu.on("click", ".comp-1-select-item-close", function (e) {
            e.preventDefault();
            e.stopPropagation();
            openTab(null, { push: true });
        });

        // initial hash
        if (location.hash) {
            openTab(location.hash.slice(1).trim(), { push: false });
            history.replaceState(null, "", location.hash);
        }

        // back/forward
        window.addEventListener("popstate", () => {
            const key = (location.hash || "").slice(1).trim();
            openTab(key || null, { push: false, scroll: !!key });
        });
    });
}
Comp1();
